import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCButton from '../../../../components/Simple/SMCButton';
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {TemplateSchema} from '../../../../api/DBSchema/Template';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import {isUserAdminSelector} from '../../../../store/selectors/user.selectors';

const pageSchema = PortalSettingsGetSchema.pages.notificationReports;
const pageId = pageSchema.pageId;

function PortalSettingsReportsNotifications({
    portalSettingsObject,
    setPortalSettingsData,
    isUserAdmin
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];

    const summaryReport                  = pageData[pageSchema.summaryReport];
    const summaryReportSchema            = pageSchema.summaryReportSchema;
    const summaryReportEnabled           = summaryReport[TemplateSchema.enabled];
    const summaryReportReportsUnit       = summaryReport[summaryReportSchema.reportsUnits];
    const summaryReportsDayNumber        = summaryReport[summaryReportSchema.summaryReportsDayNumber];
    const summaryReportReportsUnitValues = summaryReportSchema.reportsUnitsValues;

    const [isSummaryReportEditorOpen, setIssummaryReportEditorOpen] = useState(false);

    // Fix day number
    useEffect(() => {
        if (
            (summaryReportReportsUnit === summaryReportReportsUnitValues.weekly  && (summaryReportsDayNumber > 7 || summaryReportsDayNumber < 1)) ||
            (summaryReportReportsUnit === summaryReportReportsUnitValues.monthly && (summaryReportsDayNumber > 31 || summaryReportsDayNumber < 1))
        ) {
            setPortalSettingsData([pageId, pageSchema.summaryReport, summaryReportSchema.summaryReportsDayNumber], 7);
        }
    }, [summaryReportsDayNumber, setPortalSettingsData, summaryReportSchema, summaryReportReportsUnit, summaryReportReportsUnitValues]);

    return (
        <EditorLayout lineHeight="32px">
            {/* User details */}
            <RowLayout spacing="4px">
                <SMCCheckbox
                    checked={summaryReportEnabled}
                    onChange={e => setPortalSettingsData([pageId, pageSchema.summaryReport, TemplateSchema.enabled], e.target.checked)}
                    label={t('SMP.SETTINGS.NOTIFICATIONS.REPORTS.SEND_SUM_REPORTS')}
                    width={200}
                    inline
                />
                <span style={{ width: 160 }}>
                    <SMCSelect
                        value={summaryReportReportsUnit}
                        onChange={e => setPortalSettingsData([pageId, pageSchema.summaryReport, summaryReportSchema.reportsUnits], e.target.value)}
                        width={100}
                    >
                        <SMCOption value={summaryReportReportsUnitValues.daily}>{t('SMP.DAILY')}</SMCOption>
                        <SMCOption value={summaryReportReportsUnitValues.weekly}>{t('SMP.WEEKLY')}</SMCOption>
                        <SMCOption value={summaryReportReportsUnitValues.monthly}>{t('SMP.MONTHLY')}</SMCOption>
                    </SMCSelect>
                </span>
                <SMCButton onClick={() => setIssummaryReportEditorOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            <div>
                    {
                        summaryReportReportsUnit === summaryReportReportsUnitValues.weekly && (
                            <RowLayout spacing="4px">
                                <SMCLabel inline>{t('SMP.SETTINGS.NOTIFICATIONS.REPORTS.EVERY')}</SMCLabel>
                                <SMCSelect
                                    inline
                                    value={summaryReportsDayNumber}
                                    onChange={e => setPortalSettingsData([pageId, pageSchema.summaryReport, summaryReportSchema.summaryReportsDayNumber], parseInt(e.target.value))}
                                >
                                    <SMCOption value={1}>{t('SMP.SUNDAY')}</SMCOption>
                                    <SMCOption value={2}>{t('SMP.MONDAY')}</SMCOption>
                                    <SMCOption value={3}>{t('SMP.TUESDAY')}</SMCOption>
                                    <SMCOption value={4}>{t('SMP.WEDNESDAY')}</SMCOption>
                                    <SMCOption value={5}>{t('SMP.THURSDAY')}</SMCOption>
                                    <SMCOption value={6}>{t('SMP.FRIDAY')}</SMCOption>
                                    <SMCOption value={7}>{t('SMP.SATURDAY')}</SMCOption>
                                </SMCSelect>
                            </RowLayout>
                        )
                    }
                    {
                        summaryReportReportsUnit === summaryReportReportsUnitValues.monthly && (
                            <RowLayout spacing="4px">
                                <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.ON_DAY')}</SMCLabel>
                                <SMCSelect inline value={summaryReportsDayNumber} onChange={e => setPortalSettingsData([pageId, pageSchema.summaryReport, summaryReportSchema.summaryReportsDayNumber], parseInt(e.target.value))}>
                                    {
                                        [...Array(31)].map((e,i) => (                                        
                                            <SMCOption key={i+1} value={i+1}>{i+1}</SMCOption>
                                        ))
                                    }
                                </SMCSelect>
                                <SMCLabel inline>{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.REPORTS.OF_MONTH')}</SMCLabel>
                            </RowLayout>
                        )
                    }
                </div>

            {/* Popup windows */}
            <TemplateEditorModal
                isOpen={isSummaryReportEditorOpen}
                onRequestClose={() => setIssummaryReportEditorOpen(false)}
                defaultObject={summaryReport}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.summaryReport], val);
                    setIssummaryReportEditorOpen(false);
                }}
                templateName="summaryReport"
                hasAdministratorsTab={isUserAdmin}
                hasUsersTab={false}
            />
        </EditorLayout>
    )
}

const mapStateToProps = state => ({
    isUserAdmin: isUserAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PortalSettingsReportsNotifications);